<!--发表观点按钮类组件-->
<template>
    <div :class="{'view10Wrapper':true,'defaultWidth':buttonType=='default' ,'cardWidth':buttonType=='hasBg' ,'shadowRadius':buttonType=='hasBg' ,'cardPadding':buttonType=='hasBg',}">
        <div class="tipsGlobalText" v-if="tips!==''" v-html="tips">
            {{tips}}
        </div>
        <div class="v10Content">
        <div v-for="(it,ix) in list" :key="`vi-10-btn-${ix}`" class="v10BtnCls">
            <RButton color="themeBig"  @on-click="()=>onAction(it.radioType,it.id,it.name,it.value)" >{{it.name}}</RButton>
        </div>
        </div>
    </div>
</template>
<script>
    import RButton from '../Use/r-button'
    export default {
        name: "View10",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: []
            },
            tips:{
                type: String,
                default: '对于你的观点我很赞同！你还可以：\n'
            },
            buttonType: {
                type: String,
                default: "default"  //hasBg  有背景类
            }
        },
        data() {
            return {

            };

        },
        methods: {
            onAction(type,id,name,value){

             this.$emit('on-action',type,id,name,value)
            }

        }
    };
</script>
<style lang="less" scoped>
    .defaultWidth{
        width: 9.2rem;
    }
    .view10Wrapper {
        background: #fff;
        .v10Content{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .v10BtnCls{
            margin: .2rem 0;
        }
    }
</style>
